import { EnquiryDetails } from '@/modals/enquiry-details';
import {
    imageDetails,
    ProductDetails,
    ProductVariantDetail
} from '@/modals/product-details';
import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup, Validators, UntypedFormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { AppService } from '@services/app.service';
import { ConfigService } from '@services/config.service';
import { DateTime } from 'luxon';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';
import { SwiperOptions } from 'swiper';

@Component({
    selector: 'app-detail-view',
    templateUrl: './detail-view.component.html',
    styleUrl: './detail-view.component.scss'
})
export class DetailViewComponent implements OnInit, OnDestroy {
    whatsAppNumber:Number=0;
    destroy$: Subject<boolean> = new Subject<boolean>();

    product: ProductDetails;
    mainImage: string = '';
    registerPopup: boolean = false;
    mainImageId: number;
    subMainImageId: number;


    // image 
    endpoint: string=''

    // image
    imageIds: number[] = [];

    // size color

    // originalSizeList = [
    //   { "size": "XS", "isActive": false },
    //   { "size": "S", "isActive": false },
    //   { "size": "M", "isActive": false },
    //   { "size": "L", "isActive": false },
    //   { "size": "XL", "isActive": false },
    //   { "size": "XXL", "isActive": false }
    // ]

    // // color-size list
    // colorList: string[] = [];
    // sizeList: string[] = [];

    // filter colors and sizes
    colors: string[] = [];
    sizes: string[] = [];

    // html variable for colors and size
    color: string = '';
    size: string = '';
    selectedSize: string = '';
    selectedColor: string = '';
    selectedPrice: number = 0;

    constructor(
        private activatedRoute: ActivatedRoute,
        private cdr: ChangeDetectorRef,
        private appService: AppService,
        private toastr: ToastrService,
        private config: ConfigService
    ) { }
        public currentYear: string = DateTime.now().toFormat('y');

    ngOnInit(): void {
        this.activatedRoute.queryParams.subscribe((params) => {
            if (params['product']) {
                this.product = JSON.parse(atob(params['product']));
                console.log('PRODUCT-ID', this.product);
                this.getProducts(Number(this.product))
            }
        });
        this.endpoint = this.config.getConfig().END_POINT;
    }



    // filter colors and sizes
    tcolors: string[] = [];
    tsizes: string[] = [];
    // two changes
    tcolor: string = '';
    tsize: string = '';
    tselectedSize: string = '';
    tselectedColor: string = '';
    tselectedPrice: number = 0;
    tselectedOfferPrice: number = 0;

    getProducts(id: number) {
        this.appService.getProductById(id)
            .pipe(takeUntil(this.destroy$))
            .subscribe((products: ProductDetails) => {
                console.log('PRODUCTS', products);
                this.product = products;
                this.getImageId(this.product.imageDetails);
                this.cdr.detectChanges();

                // t-changes
                this.tsizes = [...new Set(this.product.productVariantDetails.map((tc) => tc.size))]

                this.tselectedSize = this.tsizes[0];

                this.colors = [
                    ...new Set(
                        this.product.productVariantDetails.map(
                            (detail) => detail.color
                        )
                    )
                ];
                this.selectedColor = this.colors[0];

                const selectedVariant = this.product.productVariantDetails.find(
                    (detail) => detail.size === this.tselectedSize
                );
                this.tselectedPrice = selectedVariant
                    ? selectedVariant.productSrp
                    : 0;
                    this.tselectedOfferPrice = selectedVariant
                    ? selectedVariant.productMrp
                    : 0;
                console.log('cate-price', this.tselectedPrice + 'OFFER',this.tselectedOfferPrice);
                console.log(
                    'available',
                    selectedVariant && selectedVariant.available
                        ? selectedVariant.available
                        : 'Variant not found'
                );

                this.sizes = [
                    ...new Set(
                        this.product.productVariantDetails
                            .filter((i) => i.color == this.selectedColor)
                            .map((detail) => detail.size)
                    )
                ];
                const sizeOrder = ['XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL', 'XXXXL', 'XXXXXL'];
                this.tsizes.sort((a, b) => sizeOrder.indexOf(a) - sizeOrder.indexOf(b));

                console.log('colors', this.colors, this.sizes);
                this.tselectedSize = this.sizes[0];
            });
    }

        verticalBrandImagesConfig: SwiperOptions = {
          direction: 'vertical', // 👈 enable vertical swiper
        slidesPerView: 2,
        spaceBetween: 20,
        loop: false,
        speed: 1500,
        autoplay: {
            delay: 3000,
            disableOnInteraction: false
        },
        breakpoints: {
            1440: { slidesPerView: 4.3 },
            1024: { slidesPerView: 4 },
            700: { slidesPerView: 3 },
            500: { slidesPerView: 2.5 },
            400: { slidesPerView: 2 },
            300: { slidesPerView: 2 }
        },
        navigation: {
            nextEl: '.subImage-swiper-button-next',
            prevEl: '.subImage-swiper-button-prev'
        }
    };


    brandImagesConfig: SwiperOptions = {
        slidesPerView: 2,
        spaceBetween: 20,
        loop: false,
        speed: 1500,
        autoplay: {
            delay: 3000,
            disableOnInteraction: false
        },
        breakpoints: {
            1440: { slidesPerView: 4.3 },
            1024: { slidesPerView: 4 },
            700: { slidesPerView: 3 },
            500: { slidesPerView: 2.5 },
            400: { slidesPerView: 2 },
            300: { slidesPerView: 2 }
        },
        navigation: {
            nextEl: '.subImage-swiper-button-next',
            prevEl: '.subImage-swiper-button-prev'
        }
    };

    changeImage(img) {
        console.log('changeImage', img);
        this.mainImageId = img;
    }

    // getImage(image: any) {
    //   // Find the first image that is marked as primary
    //   const id = image.find(x => x.isPrimary === true);
    //   // Set imgLoad to false to indicate that the image loading process is complete
    //   // Return the asset ID of the primary image, or undefined if no primary image was found
    //   return id ? id.assetId : undefined;
    // }

    getImageId(value: any[]): number {
        const id = value?.find((x) => x.isPrimary === true);
        this.mainImageId = id.imageDetailsId;
        this.subMainImageId = id.imageDetailsId;
        return this.mainImageId;
    }

    // getId() {
    //   const id = this.product.productVariantDetails[0].imageDetails
    //   console.log("imageDetails", this.product.productVariantDetails[0].imageDetails);
    //   this.imageIds = id?.map(x => x.imageDetailsId);
    // }

    // clickColor(color) {
    //     this.selectedColor = color;
    //     console.log('clickColor', color);
    //     // Filter all product variants that match the selected color
    //     const matchingVariants = this.product.productVariantDetails.filter(
    //         (it) => it.color === color
    //     );
    //     // Extract unique sizes from the filtered variants
    //     this.sizes = [
    //         ...new Set(matchingVariants.map((detail) => detail.size))
    //     ];
    //     this.selectedSize = this.sizes[0];

    //     console.log('matched sizes', this.sizes);

    //     const selectedVariant = this.product.productVariantDetails.find(
    //         (detail) => detail.color === this.selectedColor
    //     );

    //     this.selectedPrice = selectedVariant
    //         ? selectedVariant.varientAdditionalPrice
    //         : 0; // Set default price if no match is found
    //     console.log(
    //         'available',
    //         selectedVariant && selectedVariant.available
    //             ? selectedVariant.available
    //             : 'Variant not found'
    //     );
    //     console.log('cate-price', this.selectedPrice);
    // }

    sizeSelected(size: string) {
        // this.selectedSize = size;

        // const selectedVariant = this.product.productVariantDetails.find(
        //     (detail) => detail.size === this.selectedSize
        // );

        // this.selectedPrice = selectedVariant
        //     ? selectedVariant.varientAdditionalPrice
        //     : 0; // Set default price if no match is found


        this.tselectedSize = size;

        const selectedVariant = this.product.productVariantDetails.find(
            (detail) => detail.size === this.tselectedSize
        );

        this.tselectedPrice = selectedVariant
            ? selectedVariant.productSrp
            : 0; // Set default price if no match is found


            this.tselectedOfferPrice = selectedVariant
            ? selectedVariant.productMrp
            : 0;

    }

    showPopup() {
        this.registerPopup = !this.registerPopup;
    }

    deliveryDetailForm = new UntypedFormGroup({
        customerName: new UntypedFormControl('', Validators.required),
        phoneNumber: new UntypedFormControl('', Validators.required),
        doorNo: new UntypedFormControl('', Validators.required),
        village: new UntypedFormControl(' ', Validators.required),
        street: new UntypedFormControl('', Validators.required),
        city: new UntypedFormControl('', Validators.required),
        pincode: new UntypedFormControl('', Validators.required),
        state: new UntypedFormControl('', Validators.required),
        message: new UntypedFormControl('', Validators.required)
    });

    deliveryDetailErrorForm = {
        customerName: '',
        phoneNumber: '',
        doorNo: '',
        street: '',
        city: '',
        pincode: '',
        state: ''
    };

    deliveryValidation() {
        this.deliveryDetailErrorForm.customerName = '';
        this.deliveryDetailErrorForm.phoneNumber = '';
        this.deliveryDetailErrorForm.doorNo = '';
        this.deliveryDetailErrorForm.street = '';
        this.deliveryDetailErrorForm.city = '';
        this.deliveryDetailErrorForm.pincode = '';
        this.deliveryDetailErrorForm.state = '';

        let hasError = false;

        if (this.deliveryDetailForm.get('customerName').invalid) {
            this.deliveryDetailErrorForm.customerName = 'Name is required';
            this.deliveryDetailForm.get('customerName')?.markAsTouched();
            hasError = true;
        }
        if (this.deliveryDetailForm.get('phoneNumber').invalid) {
            this.deliveryDetailErrorForm.phoneNumber = 'Phone Number required';
            this.deliveryDetailForm.get('phoneNumber')?.markAsTouched();
            hasError = true;
        }
        if (this.deliveryDetailForm.get('doorNo').invalid) {
            this.deliveryDetailErrorForm.doorNo = 'Door No is required';
            this.deliveryDetailForm.get('doorNo')?.markAsTouched();
            hasError = true;
        }
        if (this.deliveryDetailForm.get('street').invalid) {
            this.deliveryDetailErrorForm.street = 'Street is required';
            this.deliveryDetailForm.get('street')?.markAsTouched();
            hasError = true;
        }
        if (this.deliveryDetailForm.get('city').invalid) {
            this.deliveryDetailErrorForm.city = 'City is required';
            this.deliveryDetailForm.get('city')?.markAsTouched();
            hasError = true;
        }
        if (this.deliveryDetailForm.get('pincode').invalid) {
            this.deliveryDetailErrorForm.pincode = 'PinCode required';
            this.deliveryDetailForm.get('pincode')?.markAsTouched();
            hasError = true;
        }
        if (this.deliveryDetailForm.get('state').invalid) {
            this.deliveryDetailErrorForm.state = 'State is required';
            this.deliveryDetailForm.get('state')?.markAsTouched();
            hasError = true;
        }
        if (!hasError) {
            const requestBody = {
                productId: this.product.productId,
                customerName: this.deliveryDetailForm.get('customerName').value,
                phoneNumber: this.deliveryDetailForm.get('phoneNumber').value,
                doorNo: this.deliveryDetailForm.get('doorNo').value,
                village: this.deliveryDetailForm.get('village').value,
                street: this.deliveryDetailForm.get('street').value,
                city: this.deliveryDetailForm.get('city').value,
                state: this.deliveryDetailForm.get('state').value,
                pincode: this.deliveryDetailForm.get('pincode').value,
                message: this.deliveryDetailForm.get('message').value
            };
            console.log(
                'Form-value', requestBody
            );

            this.sendEnquiry(requestBody);
        }
    }

    sendEnquiry(formValue: any) {

        this.appService
            .sendEnquiry(formValue)
            .pipe(takeUntil(this.destroy$))
            .subscribe(
                (data) => {
                    this.registerPopup = false;
                    this.toastr.success('Enquiry sent successfully!');
                    console.log('Enquiry sent', data);
                    this.deliveryDetailForm.controls['message'].setValue('Enquiry sent successfully!');
                    const enquiryDetails = {
                        productCode: this.product?.productCode, // Ensure product object exists
                        ...this.deliveryDetailForm.value,
                        message: 'Enquiry sent successfully!',
                        address: this.deliveryDetailForm.get('doorNo').value + this.deliveryDetailForm.get('city').value + this.deliveryDetailForm.get('state').value + this.deliveryDetailForm.get('pincode').value
                    };

                    this.sendWhatsapp(enquiryDetails);
                    console.log('enquiryDetails', enquiryDetails);
                },
                (error) => {
                    this.registerPopup = false;
                    if (error?.error?.message?.includes('one enquiry per product')) {
                        this.deliveryDetailForm.controls['message'].setValue('One enquiry per product allowed');
                        const enquiryDetails = {
                            productCode: this.product?.productCode, // Ensure product object exists
                            ...this.deliveryDetailForm.value,
                            message: 'One enquiry per product allowed',
                             address: this.deliveryDetailForm.get('doorNo').value + ', ' +this.deliveryDetailForm.get('city').value +', ' + this.deliveryDetailForm.get('state').value + ', ' +this.deliveryDetailForm.get('pincode').value
                        };

                        this.sendWhatsapp(enquiryDetails);
                        console.log('enquiryDetails', enquiryDetails);
                    } else {
                        this.toastr.error(error?.error?.message || 'Error sending enquiry!');
                    }
                    console.error('Error sending enquiry', error);
                }
            );
    }

sendWhatsapp(msg: any) {
  const whatsAppNumber = Number(localStorage.getItem('phoneNumber')) || 919087003398; // fallback if null
    
  const formattedMessage = encodeURIComponent(
    `🛠️ You have received a new product enquiry via the website. Please find the enquiry details below:\n\n` +
    `📋 *Enquiry Details:*\n` +
    `• Product Code: ${msg.productCode}\n` +
    `• Customer Name: ${msg.customerName}\n` +
    `• Phone Number: ${msg.phoneNumber}\n` +
    `• Address: ${msg.address}\n\n` +
    `📞 Please follow up with the customer at your earliest convenience.`
  );

  const whatsappUrl = `https://api.whatsapp.com/send?phone=${whatsAppNumber}&text=${formattedMessage}`;
  window.open(whatsappUrl, '_blank');
}



//     You have received a new product enquiry via the website. Please find the enquiry details below:

// Enquiry Details:

// Product Code: 10011

// Customer Name: Arun

// Phone Number: 9698877357

// Address: 12, 26/20, Madurai, Tamil Nadu, 625020


// Please follow up with the customer at your earliest convenience.

    ngOnDestroy(): void {
        this.destroy$.complete();
    }


     hasAnyProductDetail(): boolean {
  const pd = this.product;
  return !!(pd?.modelNumber || pd?.powerSource || pd?.ratedInputPower || pd?.voltage ||
            pd?.speedSettings || pd?.noLoadSpeed || pd?.weightKg || pd?.dimensions ||
            pd?.drillingDiameterSteel || pd?.drillingDiameterWood || pd?.includedAccessories || pd?.warrantyMonths);
}

}
